import { css } from '@bts-web/utils-style-engine';
import { FC, PropsWithChildren } from 'react';

export const TwoFaContentWrap: FC<PropsWithChildren> = ({ children }) => {
  return (
    <div
      className={css({
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
        justifyContent: 'center',
        gap: { base: 'small', md: 'medium' },
      })}
    >
      {children}
    </div>
  );
};
